import api from '../api'

const fetchReports = (params = {}) => {
  return api.get('/reports/export', { params: { ...params } })
}
const fetchReportsList = (params = {}) => {
  return api.get('/reports', { params: { ...params } })
}

const fetchReportsById = (id, params = {}) => {
  return api.get(`/reports/${id}`, { params: { ...params } })
}

export { fetchReports, fetchReportsById, fetchReportsList }
